import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import { ToastContainer } from "react-toastify";

import { 
    getProfile as onGetProfile, 
    updateProfile as onUpdateProfile 
} from "store/actions";

import EditProfileModal from "./EditProfileModal";

const Profile = () => {
  document.title = "Mon profil | CinzanEdu";

  const dispatch = useDispatch();
  const [profile, setProfile] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const profileSelector = createSelector(
    (state) => state.profileReducer,
    (profileReducer) => ({
      profile: profileReducer.profile,
      loading: profileReducer.loading,
    })
  );

  const { profile: reduxProfile } = useSelector(profileSelector);

  useEffect(() => {
    dispatch(onGetProfile());
  }, [dispatch]);

  useEffect(() => {
    if (reduxProfile) setProfile(reduxProfile);
  }, [reduxProfile]);

  const handleEditProfile = (values) => {
   
    dispatch(onUpdateProfile(values));
    setModalOpen(false);
  };

  const handleChangeAvatar = () => console.log("Changer l'avatar");
  const handleChangePassword = () => console.log("Modifier le mot de passe");

  return (
    <div className="profile-page my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            {/* Header */}
            <div className="text-center mb-5">
              <h1 className="fw-bold">Mon profil</h1>
              <p className="text-muted">
                Gérez vos informations personnelles et vos paramètres de sécurité.
              </p>
            </div>

            {/* Avatar */}
            {/*<Card className="mb-4 shadow-sm border-0">
              <CardBody className="text-center">
                <img
                  src={profile?.avatar || "https://placehold.co/64x64?text=Mon+Profil"}
                  alt="Avatar"
                  className="rounded-circle mb-3"
                  width={64}
                  height={64}
                />
                <div>
                  <Button outline onClick={handleChangeAvatar}>
                    Changer l’avatar
                  </Button>
                </div>
              </CardBody>
            </Card>*/}

            {/* Informations de base */}
            <Card className="mb-4 shadow-sm border-0">
              <CardBody className="d-flex justify-content-between align-items-start">
                <div>
                  <h4>Informations de base</h4>
                  <div className="py-2 border-bottom"><strong>Nom :</strong> {profile?.first_name}</div>
                  <div className="py-2 border-bottom"><strong>Prénom :</strong> {profile?.last_name}</div>
                  <div className="py-2 border-bottom"><strong>Civilité :</strong> {profile?.civility}</div>
                  <div className="py-2"><strong>Adresse :</strong> {profile?.address}</div>
                </div>
                <Button color="primary" onClick={() => setModalOpen(true)}>
                  Modifier
                </Button>
              </CardBody>
            </Card>

            
          </Col>
        </Row>
      </Container>

      <EditProfileModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        profile={profile}
        onSubmit={handleEditProfile}
      />
    </div>
  );
};

export default Profile;
